<template>
  <div class="main-content">
    <div class="container cv-content">
      <div class="cv-element" v-for="e in contents">
        <h3 style="margin-bottom: 12px">{{e.title}}</h3>
        <table class="table table-borderless table-sm" v-if="e.type === 'table' || e.type === 'listed-table'">
          <tr v-for="row in e.content">
            <td :class="e.style_title" v-html="'&blacksquare; ' + row[0]" v-if="e.type === 'listed-table'"></td>
            <td :class="e.style_title" v-html="row[0]" v-else></td>
            <td :class="e.style_content" v-html="row[1]"></td>
          </tr>
        </table>
        <ul v-else-if="e.type === 'list'">
          <li v-for="row in e.content" class="info-list-row">
            <span :class="e.style_title" v-html="row[0]"></span>
            <span :class="e.style_content" v-html="row[1]"></span>
          </li>
        </ul>
        <div v-else>
          <p v-for="row in e.content">
            <span :class="e.style_title" v-html="row[0]"></span>
            <span :class="e.style_content" v-html="row[1]"></span>
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AddInfo',
  components: {},
  data() {
    return {
      contents: [
        {
        order: 1000,
        type: 'list',
        title: "Language",
        style_title: "info-bold",
        style_content: "info-regular",
        content: [
            ["English", "TOEIC: 950 (13 May. 2018)"],
        ]
        },
        {
          order: 1100,
          type: 'list',
          title: "Additional Information",
          style_title: "info-bold",
          style_content: "info-regular",
          content: [
            ["Apr. 2015 ~ Feb. 2019","National scholarship student (Natural Science and Engineering), Korea Student Aid Foundation"],
            ["Dec. 2016 ~ May. 2019","Cadet, Research Officers for National Defense<br>"],
            ["Sep. 2018 ~ Feb. 2019","Diamond class (Top 3%), KAIST leadership mileage <br>"],
          ]
        },
        {
          order: 1200,
          type: 'list',
          title: "Military Service",
          style_title: "info-bold",
          style_content: "info-regular",
          content: [
            ["First Lieutenant, ROK Army<br>",
            "in Agency for Defense Development<br>" +
            "Jun. 2019 ~ May. 2022"]
          ]
        },
        {
          order: 1300,
          type: 'table',
          title: "Interests and Hobbies",
          style_title: "info-bold",
          style_content: "info-regular",
          content: [
            ["Robotics", "Participated in the Robotics & Maker Club at KAIST (Microrobot Research)<br>" +
            "Mar. 2015 ~ Present<br>" +
            "<a href='https://mr.kaist.ac.kr' style='padding-left: 0'>https://mr.kaist.ac.kr <span class='ext-link'><i class='fas fa-external-link-alt'></i></span></a>"],
            ["Astronomy", "Participated in the Amateur Astronomy Club at KAIST (Starflower)<br>" +
            "Sep. 2016 ~ Feb. 2018"],
          ]
        },
      ]}
  }
}
</script>

<style>
#app {
}
</style>



// WEBPACK FOOTER //
// src/components/AddInfo.vue